import { navigateTo, showError, useAsyncData } from '#imports'
import type { Ref } from 'vue'

import { getAsyncDataKey } from '@backmarket/nuxt-module-http-v2/getAsyncDataKey'
import { useHttpFetch } from '@backmarket/nuxt-module-http-v2/useHttpFetch'

import { MODELS_COMPARISON } from '../../routes-names'
import type {
  ComparisonData,
  ErrorData,
  RedirectErrorDetails,
} from '../useEnrichResultsPage/useEnrichResultsPage.types'

export function handleComparisonError(error: unknown) {
  const errorData = (error as { data?: ErrorData }).data
  const errorDetails = errorData?.errors?.[0]?.context?.payload?.detail?.error
    ?.details as RedirectErrorDetails | undefined

  if (
    errorDetails?.error_type === 'redirect_to' &&
    errorDetails.slug_1 &&
    errorDetails.slug_2
  ) {
    return navigateTo(
      {
        name: MODELS_COMPARISON.RESULTS,
        params: {
          productA: errorDetails.slug_1,
          productB: errorDetails.slug_2,
        },
      },
      { redirectCode: 301 },
    )
  }

  const errorWithCode = error as {
    statusCode?: number
    statusMessage?: string
  }

  return showError({
    statusCode: errorWithCode.statusCode || 500,
    statusMessage: errorWithCode.statusMessage || 'An error occurred',
  })
}

export function useFetchResultsPage(model1: Ref<string>, model2: Ref<string>) {
  const $httpFetch = useHttpFetch()

  return useAsyncData<ComparisonData>(
    () =>
      getAsyncDataKey('models-comparison-v2', {
        slug1: model1.value,
        slug2: model2.value,
      }),
    () =>
      $httpFetch('/product-page/compare/:model1/:model2', {
        pathParams: { model1: model1.value, model2: model2.value },
        ...(import.meta.client && { query: { strict_order: false } }),
      }),
  )
}
